import {
  ConflictErrorSeverity,
  ProduceJoinConflictsErrorType,
} from "@ryde/shared";

import { PRODUCE_CONFLICT_NAV_SEVERITY } from "./conflicts-nav.constants";

/**
 * Severity of a produce/join conflict group, keyed by the errorType the preview groups conflicts by.
 * Returns undefined for anything not downgraded, which leaves ConflictsNav on its critical default.
 */
export const resolveConflictNavSeverity = (
  groupedConflictsKey: string,
): ConflictErrorSeverity | undefined =>
  // Group keys are raw backend errorType strings; the same cast as getConflictsHeaders in use-conflicts.
  PRODUCE_CONFLICT_NAV_SEVERITY[
    groupedConflictsKey as ProduceJoinConflictsErrorType
  ];
